import { Ghost } from "lucide-react";

export function AnonymousAccessIcon({ className = "size-6 shrink-0" }: { className?: string }) {
  return <Ghost aria-hidden="true" className={className} />;
}
